import { FirmsResponseData, Data } from '../types';

export const mapResponseData = (data: FirmsResponseData[]): Data[] =>
  data.length
    ? data.map(
        (item: FirmsResponseData): Data => ({
          fcaId: item.fca.id,
          fcaStatus: item.fca.is_active,
          fcaNumber: item.fca.number,
          firmEmail: item.email,
          firmLocation: item.city,
          firmName: item.name,
          id: item.id.toString(),
          lmcStatus: item.is_active,
          registeredAt: item.registered_at,
          ddStatus: item.dd_status,
        }),
      )
    : [];
